import { render, staticRenderFns } from "./about-navigation-Item.vue?vue&type=template&id=371a3772&lang=pug&"
import script from "./about-navigation-Item.vue?vue&type=script&lang=ts&"
export * from "./about-navigation-Item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports